import { notificationService } from '@/api'
import { IUser } from '@/interface'
import { DP } from '@/ui'
import { queryClient, SHOW, tryOnce } from '@/utils'
import { useQuery } from '@tanstack/react-query'
import { Bell } from 'lucide-react'
import { NavLink, Route, Routes } from 'react-router-dom'
import MerchantHome from './home'
import EnterAmount from './enter_amount'
import AcceptPaymentByQR from './accept_payment_qr'
import Accounts from './accounts'
import TransactionHistory from './history'
import { useLocation } from 'react-router-dom'
import { popup } from '@/popup_handler'
import { useAppStore } from '@/store'
import { useEffect } from 'react'

const MerchantApp = () => {
  const { wallet } = useAppStore((state) => state) as any

  const { pathname } = useLocation()
  const hideNav = pathname.includes('enteramount') || pathname.includes('accept') || pathname.includes('notifications')

  const user = queryClient.getQueryData(['user']) as IUser
  const notifications = useQuery(['notifications'], () => notificationService.GetAll())
  useEffect(() => {
    if (!wallet) return
    const isSkipBackup = localStorage.getItem(`skip_backup:${wallet._id}`)
    if (!wallet?.backup && wallet?.is_local && isSkipBackup !== 'true') {
      tryOnce('backup_reminder' + wallet._id, () => popup.open('backup_reminder'), 1, 'day')
    } else if (wallet?.backup && !wallet?.is_local && !wallet.mnemonicCipher) {
      popup.open('recovery_reminder')
    }
  }, [wallet])
  return (
    <div className={`relative flex flex-col h-full w-full p-4`}>
      {/* Top Bar */}
      <div className="flex gap-4 items-center top-0 w-full z-10 justify-end">
        <NavLink to="/dashboard/notifications/" className="p-2 hover:bg-gray-200 active:bg-gray-100 rounded-full relative">
          <Bell className="text-gray-500" />
          <div {...SHOW(notifications.data?.result.length)} className="w-2 h-2 bg-[#f27821] absolute rounded-full top-[5px] right-[5px] animate-pulse" />
        </NavLink>
        <NavLink to="/dashboard/settings" className="h-[52px] w-[52px] shrink-0 rounded-full flex items-center justify-center text-primary active:opacity-90">
          <DP name={user.name} size="36px" className="text-[18px]" />
        </NavLink>
      </div>

      {/* Bottom Navigation */}
      {/* Bottom Navigation */}
      {!hideNav && (
        <div className="absolute left-0 shadow-[0px_0px_80px_-6px_#00000052] bg-white flex justify-around bottom-0 cursor-pointer shadow-md py-3 w-full z-20">
          <NavLink to="/dashboard/" end className={({ isActive }) => `text-gray-600 ${isActive ? 'text-[#f27821] border-t-2 border-[#f27821] pt-1' : 'hover:text-[#f27821]'}`}>
            Home
          </NavLink>

          <NavLink to="/dashboard/merchant/Accounts" className={({ isActive }) => `text-gray-600 ${isActive ? 'text-[#f27821] border-t-2 border-[#f27821] pt-1' : 'hover:text-[#f27821]'}`}>
            Account
          </NavLink>

          <NavLink to="/dashboard/merchant/transactionhistory" className={({ isActive }) => `text-gray-600 ${isActive ? 'text-[#f27821] border-t-2 border-[#f27821] pt-1' : 'hover:text-[#f27821]'}`}>
            History
          </NavLink>
        </div>
      )}

      {/* Routes */}
      <Routes>
        <Route path="/" element={<MerchantHome />} />
        <Route path="/merchant/enteramount" element={<EnterAmount />} />
        <Route path="/merchant/Accounts" element={<Accounts />} />
        <Route path="/merchant/transactionhistory" element={<TransactionHistory />} />
        <Route path="/merchant/enteramount/accept/:amount" element={<AcceptPaymentByQR />} />
      </Routes>
      {wallet && !wallet?.is_local ? (
        <div className="bg-red-500 text-white  w-full left-0 text-center  py-2 z-10 absolute bottom-12">
          This account is not available! <br />{' '}
          <button onClick={() => popup.open('recovery_reminder')} className="underline font-black">
            Recover Now
          </button>
        </div>
      ) : null}
    </div>
  )
}

export default MerchantApp
